import { discountedCents } from '@/utils/discountedCents';

/** Bump when the disclosure copy or terms materially change. */
export const CONSENT_TERMS_VERSION = '2026-10-08-presale-trial';

type SummaryLike = {
  products: Array<{ monthly_price_cents: number; first_charge_cents?: number }>;
  discount?: { percent_off?: number; amount_off_cents?: number };
};

/** Amount actually charged on trial_end — proration + discount applied. Matches OrderSummaryAside. */
export function disclosedFirstChargeCents(summary: SummaryLike): number {
  const anyProrated = summary.products.some((p) => p.first_charge_cents != null);
  const base = summary.products.reduce(
    (sum, p) => sum + (anyProrated ? (p.first_charge_cents ?? p.monthly_price_cents) : p.monthly_price_cents),
    0,
  );
  if (!summary.discount) return base;
  return discountedCents(base, {
    percentOff: summary.discount.percent_off,
    amountOffCents: summary.discount.amount_off_cents,
  });
}

